import type { SupportedRepubName } from '@cx-web/domain-types';

export const FAVICON_CONFIGS = {
  WS: 'ws-favicon.svg',
  OC: 'oc-favicon.svg',
  US: 'us-favicon.png',
  GZ: 'gz-favicon.ico',
} satisfies Record<SupportedRepubName, string>;
